// 🔧 owner_generator.js
// ✅ Purpose: Generates realistic owner profiles for LGV Seed Engine entries
// ✅ Features:
// - Creates realistic owner names and locations
// - Keeps owner generation separate from vehicle generation
// - Future-ready for profile photos, biographies, and AI-generated owners
// - Can be shared across all event industries
// - Fully block-commented for clarity and future devs

const OWNERS = [
  { firstName: "Mike", lastName: "Johnson", city: "Portland", state: "OR" },
  { firstName: "Sarah", lastName: "Mitchell", city: "Salem", state: "OR" },
  { firstName: "Robert", lastName: "Garcia", city: "Eugene", state: "OR" },
  { firstName: "Angela", lastName: "Brooks", city: "Vancouver", state: "WA" },
  { firstName: "David", lastName: "Thompson", city: "Beaverton", state: "OR" },
  { firstName: "Kim", lastName: "Parker", city: "Hillsboro", state: "OR" },
  { firstName: "Chris", lastName: "Lee", city: "Tigard", state: "OR" },
  { firstName: "Jordan", lastName: "Reed", city: "Gresham", state: "OR" },
  { firstName: "Patricia", lastName: "Wilson", city: "Lake Oswego", state: "OR" },
  { firstName: "Marcus", lastName: "Bennett", city: "Wilsonville", state: "OR" },
];

export const generateOwner = ({
  index = 0,
} = {}) => {
  const owner =
    OWNERS[index % OWNERS.length];

  return {
    ownerName:
      `${owner.firstName} ${owner.lastName}`,

    ownerFirstName:
      owner.firstName,

    ownerLastName:
      owner.lastName,

    ownerCity:
      owner.city,

    ownerState:
      owner.state,
  };
};